(() => {
  'use strict';
  const directory = document.querySelector('[data-fit-directory]');
  if (!directory) return;
  const localeStrings = JSON.parse(document.getElementById('CatLocaleStrings')?.textContent || '{}');
  const localText = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{'+name+'}', String(value)), localeStrings['client_'+key] || '');
  const input = directory.querySelector('input[type="search"]');
  const cards = [...directory.querySelectorAll('[data-fit-url]')];
  const filters = [...directory.querySelectorAll('[data-fit-filter]')];
  const more = directory.querySelector('[data-fit-more]');
  const status = directory.querySelector('[data-fit-status]');
  const dialog = document.getElementById('FitDirectoryDialog');
  const body = dialog.querySelector('[data-fit-dialog-body]');
  const title = dialog.querySelector('h2');
  const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const search = new Map(cards.map(card => [card, normalise(card.dataset.fitSearch)]));
  let fit = '', limit = 12, request, catalogLoading = false, catalogError = false;
  function render() {
    const terms = normalise(input.value.trim()).split(/\s+/).filter(Boolean);
    const matches = cards.filter(card => (!fit || card.dataset.fit === fit) && terms.every(term => search.get(card).includes(term)));
    const visible = new Set(matches.slice(0, limit));
    cards.forEach(card => { card.hidden = !visible.has(card); });
    status.textContent = catalogLoading ? localText('catalog_loading') : matches.length ? localText('catalog_count', {shown:Math.min(limit,matches.length), count:matches.length}) : localText('catalog_empty');
    if (catalogError) status.textContent += ' '+localText('catalog_error');
    more.hidden = matches.length <= limit;
  }
  input.addEventListener('input', () => { limit = 12; render(); });
  filters.forEach(button => button.addEventListener('click', () => {
    fit = button.dataset.fitFilter; limit = 12;
    filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    render();
  }));
  more.addEventListener('click', () => { const next = cards.filter(card => card.hidden); limit += 12; render(); next.find(card => !card.hidden)?.focus({preventScroll:true}); });
  directory.addEventListener('click', async event => {
    const link = event.target.closest('[data-fit-url]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !window.SobremesaDialogs) return;
    if (!window.SobremesaDialogs.open(dialog.id, link)) return;
    event.preventDefault(); request?.abort();
    const controller = request = new AbortController();
    title.textContent = link.querySelector('strong').textContent;
    body.replaceChildren(); body.setAttribute('aria-busy', 'true');
    const loading = document.createElement('p'); loading.className = 'fit-directory-loading'; loading.setAttribute('role', 'status'); loading.textContent = localText('measure_loading'); body.append(loading);
    const timeout = setTimeout(() => controller.abort(), 15000);
    const productLink = document.createElement('a'); productLink.href = link.href; productLink.className = 'fit-directory-product-link'; productLink.textContent = localText('view_sizes');
    try {
      const response = await fetch(link.href, {signal:controller.signal,credentials:'same-origin'});
      if (!response.ok) throw new Error('Product unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller !== request) return;
      const guide = parsed.querySelector('#ProductSizeDialog .product-size-body');
      if (!guide) throw new Error('Size guide unavailable');
      if (guide.querySelector('table')) {
        body.replaceChildren(...guide.childNodes);
      } else {
        const note = document.createElement('p'); note.className = 'product-size-intro';
        note.textContent = localText('measure_missing');
        body.replaceChildren(note);
      }
      body.append(productLink);
    } catch (error) {
      if (controller !== request || !dialog.open) return;
      const message = document.createElement('p'); message.className = 'fit-directory-error'; message.setAttribute('role','alert'); message.textContent = localText('measure_error');
      body.replaceChildren(message, productLink);
    } finally { clearTimeout(timeout); if (controller === request) body.removeAttribute('aria-busy'); }
  });
  dialog.addEventListener('close', () => { request?.abort(); });
  render();
  async function completeCatalog() {
    let next = directory.querySelector('[data-fit-next]')?.href;
    if (!next) return;
    catalogLoading = true; render();
    const visited = new Set();
    try {
      while (next && !visited.has(next)) {
        visited.add(next);
        const url = new URL(next, location.href);
        if (url.origin !== location.origin) throw new Error('Invalid catalogue page');
        const response = await fetch(url, {credentials:'same-origin',signal:AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Catalogue unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = [...page.querySelectorAll('[data-fit-directory] [data-fit-url]')];
        const known = new Set(cards.map(card => card.dataset.fitUrl));
        incoming.filter(card => !known.has(card.dataset.fitUrl)).forEach(card => {
          card.hidden = true; cards.push(card); search.set(card, normalise(card.dataset.fitSearch)); directory.querySelector('[data-fit-results]').append(card);
        });
        const nextLink = page.querySelector('[data-fit-next]')?.getAttribute('href');
        next = nextLink ? new URL(nextLink, url).href : null;
      }
      directory.querySelector('[data-fit-pagination]')?.remove();
    } catch { catalogError = true; }
    finally { catalogLoading = false; render(); }
  }
  completeCatalog();
})();
